module.exports = __webpack_public_path__ + "img/gf1.8f46288d.png";